var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgX(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.90625 10C0.523438 10.375 0.507812 11.0625 0.914062 11.4609C1.3125 11.8594 2 11.8438 2.375 11.4688L6 7.84375L9.625 11.4609C10.0156 11.8516 10.6875 11.8594 11.0859 11.4531C11.4844 11.0547 11.4844 10.3828 11.0938 9.99219L7.46875 6.375L11.0938 2.75C11.4844 2.35938 11.4844 1.6875 11.0859 1.28906C10.6875 0.882812 10.0156 0.890625 9.625 1.28125L6 4.89844L2.375 1.27344C2 0.898438 1.3125 0.882812 0.914062 1.28125C0.507812 1.67969 0.523438 2.36719 0.90625 2.75L4.53125 6.375L0.90625 10Z",
    fill: "#3C3C43",
    fillOpacity: 0.6
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgX);
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIiIGhlaWdodD0iMTIiIHZpZXdCb3g9IjAgMCAxMiAxMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTAuOTA2MjUgMTBDMC41MjM0MzggMTAuMzc1IDAuNTA3ODEyIDExLjA2MjUgMC45MTQwNjIgMTEuNDYwOUMxLjMxMjUgMTEuODU5NCAyIDExLjg0MzggMi4zNzUgMTEuNDY4OEw2IDcuODQzNzVMOS42MjUgMTEuNDYwOUMxMC4wMTU2IDExLjg1MTYgMTAuNjg3NSAxMS44NTk0IDExLjA4NTkgMTEuNDUzMUMxMS40ODQ0IDExLjA1NDcgMTEuNDg0NCAxMC4zODI4IDExLjA5MzggOS45OTIxOUw3LjQ2ODc1IDYuMzc1TDExLjA5MzggMi43NUMxMS40ODQ0IDIuMzU5MzggMTEuNDg0NCAxLjY4NzUgMTEuMDg1OSAxLjI4OTA2QzEwLjY4NzUgMC44ODI4MTIgMTAuMDE1NiAwLjg5MDYyNSA5LjYyNSAxLjI4MTI1TDYgNC44OTg0NEwyLjM3NSAxLjI3MzQ0QzIgMC44OTg0MzggMS4zMTI1IDAuODgyODEyIDAuOTE0MDYyIDEuMjgxMjVDMC41MDc4MTIgMS42Nzk2OSAwLjUyMzQzOCAyLjM2NzE5IDAuOTA2MjUgMi43NUw0LjUzMTI1IDYuMzc1TDAuOTA2MjUgMTBaIiBmaWxsPSIjM0MzQzQzIiBmaWxsLW9wYWNpdHk9IjAuNiIvPgo8L3N2Zz4K";
export { ForwardRef as ReactComponent };